import styled from 'styled-components';
import Row from './row';

const HeaderRow = styled(Row)`
  background-color: var(--grey100);
  border-bottom: 1px solid var(--grey300);
  height: 50px;
`;
export default HeaderRow;
